// single pages
const Unauthorized = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/403.vue");
const homePage = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/Home.vue");
const loginPage = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/Login.vue");
const ssoAuthPage = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/sso/Auth.vue");
const authorize = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/Authorize.vue");
const notFoundPage = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/NotFound.vue");
const DefaultPage = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/Default.vue");
const changePassword = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/ChangePass.vue");
const policy = () =>
  import(/* webpackChunkName: "common-page" */ "../pages/policy");
const deleteAccountInstruction = () =>
  import(
    /* webpackChunkName: "common-page" */ "../pages/deleteAccountInstruction"
  );
const menu = () =>
  import(/* webpackChunkName: "calendar-page" */ "../pages/menu/index.vue");
// lịch làm việc
const calendar = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendar/calendar.vue"
  );
const calendarRequest = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendar/calendarRequest.vue"
  );
const calendarDetail = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendar/calendar-detail.vue"
  );
const updateWork = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendar/update-work.vue"
  );
const calendarImportExcel = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendar/import-excel"
  );
const calendarImportExcelError = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendar/import-excel/import-err.vue"
  );

// nhóm công việc AFS
const groupCalendarAFS = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/groupCalendar/groupCalendarAFS.vue"
  );
const groupCalendarAFSAdd = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/groupCalendar/groupCalendarAFSAdd.vue"
  );
const groupCalendarAFSDetail = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/groupCalendar/groupCalendarAFSDetail.vue"
  );
const groupCalendarAFSEdit = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/groupCalendar/groupCalendarAFSEdit.vue"
  );
const groupCalendarAFSImport = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/groupCalendar/groupCalendarAFSImport.vue"
  );
const importGroupCalendarError = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/groupCalendar/import-group-calendar/import-err.vue"
  );
const importGroupCalendarSuccess = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/groupCalendar/import-group-calendar/import-success.vue"
  );
// danh mục công việc AFS
const catCalendarAFS = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "@/pages/calendarAFS/catCalendar/catCalendarAFS.vue"
  );
const catCalendarAFSDetail = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "@/pages/calendarAFS/catCalendar/catCalendarAFSDetail.vue"
  );
const catCalendarAFSAdd = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "@/pages/calendarAFS/catCalendar/catCalendarAFSAdd.vue"
  );
const catCalendarAFSEdit = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "@/pages/calendarAFS/catCalendar/catCalendarAFSEdit.vue"
  );
const catCalendarAFSImport = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/catCalendar/catCalendarAFSImport.vue"
  );
const importCatCalendarError = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/catCalendar/import-cat-calendar/import-err.vue"
  );
const importCatCalendarSuccess = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "../pages/calendarAFS/catCalendar/import-cat-calendar/import-success.vue"
  );
// lịch làm việc AFS
const calendarAFS = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "@/pages/calendarAFS/calendars/calendarAFS.vue"
  );
const calendarAFSRequest = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "@/pages/calendarAFS/calendars/calendarAFSRequest.vue"
  );
  const createComboContact = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "@/pages/contract/addContactCombo.vue"
  );
const calendarAFSDetail = () =>
  import(
    /* webpackChunkName: "calendar-page" */ "@/pages/calendarAFS/calendars/calendarAFSDetail.vue"
  );

const stickerStandee = () =>
  import(
    /* webpackChunkName: "job-page" */ "@/pages/sticker-standee/index.vue"
  );
const stickerStandeeSaleDetail = () =>
  import(
    /* webpackChunkName: "job-page" */ "@/pages/sticker-standee/sale-detail.vue"
  );
const stickerStandeeAfsDetail = () =>
  import(
    /* webpackChunkName: "job-page" */ "@/pages/sticker-standee/afs-detail.vue"
  );

const File = () =>
  import(/* webpackChunkName: "file-page" */ "@/pages/file/index.vue");
const FileDetail = () =>
  import(/* webpackChunkName: "file-page" */ "@/pages/file/detail.vue");
const FileImport = () =>
  import(/* webpackChunkName: "file-page" */ "@/pages/file/import.vue");

const GPDKKD = () =>
  import(/* webpackChunkName: "job-page" */ "@/pages/gpdkkd/index.vue");
const GPDKKDZipFile = () =>
  import(/* webpackChunkName: "job-page" */ "@/pages/gpdkkd/zip-file.vue");
const GPDKKDSaleDetail = () =>
  import(/* webpackChunkName: "job-page" */ "@/pages/gpdkkd/sale-detail.vue");
const GPDKKDAfsDetail = () =>
  import(/* webpackChunkName: "job-page" */ "@/pages/gpdkkd/afs-detail.vue");

// chứng từ
const listLicence = () =>
  import(
    /* webpackChunkName: "job-page" */ "@/pages/calendarAFS/licence/list.vue"
  );
const detailLicence = () =>
  import(
    /* webpackChunkName: "job-page" */ "@/pages/calendarAFS/licence/detail.vue"
  );
// T+2
const paymentT2 = () =>
  import(
    /* webpackChunkName: "job-page" */ "@/pages/calendarAFS/paymentT+2/list.vue"
  );
const detailPaymentT2 = () =>
  import(
    /* webpackChunkName: "job-page" */ "@/pages/calendarAFS/paymentT+2/detail.vue"
  );

const mcDkkd = () =>
  import(/* webpackChunkName: "job-page" */ "@/pages/mc-dkkd/index.vue");
const mcCcct = () =>
  import(/* webpackChunkName: "job-page" */ "@/pages/mc-ccct/index.vue");
const mcCcctLs = () =>
  import(/* webpackChunkName: "job-page" */ "@/pages/mc-ccct/list.vue");
const mcCcctJoget = () =>
  import(/* webpackChunkName: "job-page" */ "@/pages/mc-ccct/joget.vue");
// Chấm công bổ sung
const attendance = () =>
  import(
    /* webpackChunkName: "ccbs-page" */ "../pages/addtional-timekepping/attendance"
  );
const attendanceDetail = () =>
  import(
    /* webpackChunkName: "ccbs-page" */ "@/pages/addtional-timekepping/attendanceDetail.vue"
  );
const timekeeping = () =>
  import(
    /* webpackChunkName: "ccbs-page" */ "@/pages/addtional-timekepping/timekeeping.vue"
  );
const timekeepingDetail = () =>
  import(
    /* webpackChunkName: "ccbs-page" */ "@/pages/addtional-timekepping/timekeepingDetail.vue"
  );
const timekeepingAdd = () =>
  import(
    /* webpackChunkName: "ccbs-page" */ "../pages/addtional-timekepping/timekeepingAdd.vue"
  );
const timekeepingEdit = () =>
  import(
    /* webpackChunkName: "ccbs-page" */ "../pages/addtional-timekepping/timekeepingEdit.vue"
  );
// Merchant
const listMC = () =>
  import(/* webpackChunkName: "merchant-page" */ "@/pages/merchant/listMC.vue");
const listMCOnboard = () =>
  import(/* webpackChunkName: "merchant-page" */ "@/pages/merchant/listMCOnboard.vue");
const mapListMC = () =>
  import(
    /* webpackChunkName: "map1mc-page" */ "@/pages/merchant/mapListMC.vue"
  );
const mapListMCV3 = () =>
  import(
    /* webpackChunkName: "map2mc-page" */ "@/pages/merchant/mapListMCV3.vue"
  );
const MerchantDetail = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/merchantDetail.vue"
  );
const MerchantAdd = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/MerchantAdd.vue"
  );
const MerchantEdit = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/MerchantEdit.vue"
  );
const transMC = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/transMC.vue"
  );
const historyTrans = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/historyTrans.vue"
  );
const detailTrans = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/detailTrans.vue"
  );
const listMCNextlend = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/listMCNextlend.vue"
  );
const mcNextlendDetail = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/mcNextlendDetail.vue"
  );
const MCLanding = () =>
  import(
    /* webpackChunkName: "merchant-page" */ "@/pages/merchant/merchantLanding.vue"
  );

// DEVICE LOCATION
const listDeviceLocation = () =>
  import(
    /* webpackChunkName: "device-location-page" */ "@/pages/merchant/device-location/index.vue"
  );
const detailDeviceLocation = () =>
  import(
    /* webpackChunkName: "device-location-page" */ "@/pages/merchant/device-location/detail.vue"
  );

// nextlend
const customerNextlend = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/nextlend/customer/list.vue"
  );
const equityNextlend = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/nextlend/equity/webview.vue"
  );

// Quản lý CTV
const listCollaborators = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/collaborators/listCollaborators.vue"
  );

  const listTingboxCtv = () =>
    import(
      /* webpackChunkName: "user-page" */ "@/pages/collaborators/listTingboxCtv.vue"
    );
  const DetailTingboxCtv = () =>
    import(
      /* webpackChunkName: "user-page" */ "@/pages/collaborators/detailTingBoxCtv.vue"
    );
const importCollaborator = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/collaborators/importCollaborator.vue"
  );
const manageMC = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/collaborators/manageMC.vue"
  );
const manageMCDetail = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/collaborators/manageMCDetail.vue"
  );
const TempCTV = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/collaborators/TempCTV/contractAgent.vue"
  );
const assignMC = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/collaborators/assignMC.vue"
  );
const collaboratorDetail = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/collaborators/collaboratorDetail.vue"
  );
const historyAssignMC = () =>
  import(
    /* webpackChunkName: "user-page" */ "@/pages/collaborators/historyAssignMC.vue"
  );
// Nhân viên
const staff = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/staff/index.vue");
const staffAdd = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/staff/staff-add.vue");
const staffEdit = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/staff/staff-edit.vue");
const staffDetail = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/staff/staff-detail.vue");
// Cài đặt
const role = () =>
  import(/* webpackChunkName: "config-page" */ "../pages/role/role.vue");
const roleAdd = () =>
  import(/* webpackChunkName: "config-page" */ "../pages/role/role-add.vue");
const roleEdit = () =>
  import(/* webpackChunkName: "config-page" */ "../pages/role/role-edit.vue");

const configLocation = () =>
  import(
    /* webpackChunkName: "config-page" */ "@/pages/config-location/index.vue"
  );
// Báo cáo
const reportDeviceContract = () =>
  import(
    /* webpackChunkName: "config-page" */ "@/pages/report/report-device-contract.vue"
  );
const reportDevice = () =>
  import(
    /* webpackChunkName: "config-page" */ "../pages/report/report-device.vue"
  );
const reportAttentdent = () =>
  import(
    /* webpackChunkName: "config-page" */ "../pages/report/report-attentdent.vue"
  );
const reportMerchant = () =>
  import(
    /* webpackChunkName: "config-page" */ "../pages/report/report-merchant.vue"
  );
const reportWork = () =>
  import(
    /* webpackChunkName: "config-page" */ "../pages/report/report-work.vue"
  );
const reportWorkCVKD = () =>
  import(
    /* webpackChunkName: "config-page" */ "@/pages/report/report-work-cvkd.vue"
  );

// Hợp đồng
const contractDetailEcommerce = () =>
  import(
    /* webpackChunkName: "contract-page" */ "../pages/contract/contract-detail-ecommerce.vue"
  );

  // Hợp đồng
const contracMagabiz = () =>
  import(
    /* webpackChunkName: "contract-page" */ "../pages/contract/contractMegabiz.vue"
  );
const historyActionDetails = () =>
  import(
    /* webpackChunkName: "contract-page" */ "../pages/contract/history-action-details.vue"
  );
const contractDetailPaper = () =>
  import(
    /* webpackChunkName: "contract-page" */ "../pages/contract/contract-detail-paper.vue"
  );
const ReviewContract = () =>
  import(
    /* webpackChunkName: "contract-page" */ "../pages/contract/review/review.vue"
  );
const Posapp = () =>
  import(
    /* webpackChunkName: "contract-page" */ "../pages/contract/posapp.vue"
  );
const ReviewApendixContract = () =>
  import(
    /* webpackChunkName: "contract-page" */ "../pages/contract/review/review-appendix.vue"
  );
const ReviewEmailContract = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/review/review-email.vue"
  );
const ReviewApendixEmailContract = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/review/review-email-apendix.vue"
  );
const importStaffOne = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/staff/import/step-one.vue"
  );
const importStaffTwo = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/staff/import/step-two.vue"
  );
const importStaffFinal = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/staff/import/step-final.vue"
  );
const contractManager = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/contract.vue"
  );
const appendixManager = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/appendix.vue"
  );
const qlbhDetail = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/qlbhDetail.vue"
  );
const salesManagerPaperDetail = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/sales-paper-detai.vue"
  );
const middlewarePdf = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/middle-ware-pdf.vue"
  );
const approveUpdate = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/approveUpdate/approveUpdateContract.vue"
  );
const historyUpdate = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/approveUpdate/historyUpdate.vue"
  );
const appendixFeeVisa = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/appendix-fee-visa.vue"
  );
const preferentialMerchantRegistration = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/endow/preferential-merchant-registration.vue"
  );
const processingIncentiveRegistration = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/endow/processing-incentive-registration.vue"
  );
const detailIncentiveRegistration = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/endow/detail-incentive-registration.vue"
  );
const listInfoChange = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/infoChange.vue"
  );
const detailInfoChange = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/infoChangeDetail.vue"
  );
const paperContractManager = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/paperContractManager/index.vue"
  );
const detailPaperContractManager = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/paperContractManager/detail.vue"
  );
const listMcBIDV = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "../pages/contract/mc-bidv.vue"
  );

  const listPrpopsed = () =>
    import(
      /* webpackChunkName: "contract1-page" */ "../pages/contract/proposed-fees.vue"
    );

     const requestSalesCombo = () =>
    import(
      /* webpackChunkName: "contract1-page" */ "../pages/contract/saleCombo/index.vue"
    );
     const requestSalesComboDetail = () =>
    import(
      /* webpackChunkName: "contract1-page" */ "../pages/contract/saleCombo/detail.vue"
    );

// Tracking
const tracking = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/tracking/index.vue");
const trackingDetail = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/tracking/detail.vue");
// Agent
const agent = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/agent");
const agentCreate = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/agent/create");
const agentUpdate = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/agent/update");
const agentDetail = () =>
  import(/* webpackChunkName: "user-page" */ "../pages/agent/detail");

import { DOMAIN_TITLE } from "../.env";

const IntroCTVPage = () =>
  import(
    /* webpackChunkName: "common-page" */ "@/pages/pageAppMb/intro-ctv.vue"
  );
const PrivacyNextAgent = () =>
  import(
    /* webpackChunkName: "common-page" */ "@/pages/privacy/privacy-nextagent.vue"
  );

// Phieu thu
const downloadFile = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/download.vue"
  );
const listReceipts = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/list-receipts.vue"
  );
const historyReceipts = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/history-receipts.vue"
  );
const detailReceipts = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/detail-receipts.vue"
  );
const editReceipts = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/edit-receipts.vue"
  );
const addReceipts = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/add-receipts.vue"
  );
const compareFile = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/compare-file.vue"
  );

// Hoàn tiền phiếu thu
const listRefund = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/refund/list.vue"
  );
const detailRefund = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/refund/detail.vue"
  );
// Yêu cầu thanh toán
const listOrder = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/payment-order/list.vue"
  );
const detailOrder = () =>
  import(
    /* webpackChunkName: "receipts-page" */ "@/pages/receipts/payment-order/detail.vue"
  );
// leads
const listLeads = () =>
  import(/* webpackChunkName: "lead-page" */ "@/pages/leads/index.vue");
const addLead = () =>
  import(/* webpackChunkName: "lead-page" */ "@/pages/leads/add-lead.vue");
const editLead = () =>
  import(/* webpackChunkName: "lead-page" */ "@/pages/leads/edit-lead.vue");
const detailLead = () =>
  import(/* webpackChunkName: "lead-page" */ "@/pages/leads/detail-lead.vue");
const authLead = () =>
  import(/* webpackChunkName: "lead-page" */ "@/pages/leads/auth-info.vue");
const importLead = () =>
  import(/* webpackChunkName: "lead-page" */ "@/pages/leads/import-lead.vue");
const importLeadErr = () =>
  import(
    /* webpackChunkName: "lead-page" */ "@/pages/leads/import-lead/import-err.vue"
  );
const importLeadSuccess = () =>
  import(
    /* webpackChunkName: "lead-page" */ "@/pages/leads/import-lead/import-success.vue"
  );

// Commissions
const historyComissions = () =>
  import(
    /* webpackChunkName: "common-page" */ "@/pages/collaborators/historyComissions.vue"
  );

// Thiết bị
const listDevice = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/devices/listDevice.vue"
  );
const detailDevice = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/devices/detailDevice.vue"
  );
const editDevice = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/devices/editDevice.vue"
  );
const equipmentHandoverConfirmation = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/equipmentHandover/confirm.vue"
  );
const equipmentHandoverList = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/equipmentHandover/layoutTabs.vue"
  );
  // phiêu thu đại lý
const listAgentReceipt = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/agent-receipt/list.vue"
  );
const detailAgentReceipt = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/agent-receipt/detail.vue"
  );

const addAgentReceipt = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/agent-receipt/add.vue"
  );

const listWarranty = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/warranty/index.vue"
  );
const warrantyRequest = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/warranty/request.vue"
  );
const warrantyDetail = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/warranty/detail.vue"
  );
const listErrorType = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/errorType/index.vue"
  );
const errorTypeRequest = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/errorType/request.vue"
  );
const listMaterialStatus = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/material/list-status.vue"
  );
const listMaterialWarehourse = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/material/list-warehouse.vue"
  );
const detailMaterial = () =>
  import(
    /* webpackChunkName: "contract1-page" */ "@/pages/device/material/detail.vue"
  );
const rentDevice = () =>
  import(
    /* webpackChunkName: "job-page" */ "@/pages/device/rent-device/index.vue"
  );

// Danh mục thiết bị
const catDevice = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catDevice/catDevice.vue"
  );
  // Sim kèm tingbox
  const AttachedSim = () =>
    import(
      /* webpackChunkName: "warehouse-page" */ "@/pages/device/attachedSim/list.vue"
    );

const addCatDevice = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catDevice/addCatDevice.vue"
  );
const editCatDevice = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catDevice/editCatDevice.vue"
  );
const detailCatDevice = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catDevice/detailCatDevice.vue"
  );

// importWarehouse
const listImportWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/importWarehouse/list.vue"
  );
const addImportWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/importWarehouse/add.vue"
  );
const detaiImportWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/importWarehouse/detail.vue"
  );

// tranfer agency

const listTransferAgency = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/transferAgency/list.vue"
  );
  const transferAgencyDetail = () =>
    import(
      /* webpackChunkName: "warehouse-page" */ "@/pages/device/transferAgency/detail.vue"
    );


// transferWarehouse
const ManagerAgencyList = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/collaborators/manageAgency/list.vue"
  );

  const ManagerAgencyAdd = () =>
    import(
      /* webpackChunkName: "warehouse-page" */ "@/pages/collaborators/manageAgency/add.vue"
    );

    const ManagerAgencyDetail = () =>
      import(
        /* webpackChunkName: "warehouse-page" */ "@/pages/collaborators/manageAgency/detail.vue"
      );

       const ListAgencyPartner = () =>
      import(
        /* webpackChunkName: "warehouse-page" */ "@/pages/collaborators/partner/index.vue"
      );
         const ListAgencyPartnerDetail = () =>
      import(
        /* webpackChunkName: "warehouse-page" */ "@/pages/collaborators/partner/detail.vue"
      );

             const ListAgencyPartnerEdit = () =>
      import(
        /* webpackChunkName: "warehouse-page" */ "@/pages/collaborators/partner/edit.vue"
      );



const listTransferWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/transferWarehouse/list.vue"
  );
const addTransferWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/transferWarehouse/add.vue"
  );
const detaiTransferWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/transferWarehouse/detail.vue"
  );
const approveExportTransferWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/transferWarehouse/approve-export.vue"
  );
const approveImportTransferWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/transferWarehouse/approve-import.vue"
  );

// exportWarehouse
const exportWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/exportWarehouse/list.vue"
  );
const detailExportWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/exportWarehouse/detail.vue"
  );

// catWarehouse
const listCatWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catWarehouse/list.vue"
  );
const detailCatWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catWarehouse/detail.vue"
  );
const addCatWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catWarehouse/add.vue"
  );

  const addCatWarehouseAgency = () =>
    import(
      /* webpackChunkName: "warehouse-page" */ "@/pages/device/catWarehouse/addAgency.vue"
    );

const editCatWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catWarehouse/edit.vue"
  );
const editEmployeeCatWarehouse = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/catWarehouse/editEmployee.vue"
  );

// Cau hinh gia goi Dich vu / Thiet bi
const listDeviceServicePriceConfig = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/configuration-package-price/list-device-service-config.vue"
  );
const addDeviceServicePriceConfig = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/configuration-package-price/add-device-service-config.vue"
  );
const editDeviceServicePriceConfig = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/configuration-package-price/edit-device-service-config.vue"
  );

// Chinh sach, HDSD
const TimekeepingRegulation = () =>
  import(
    /* webpackChunkName: "common-page" */ "@/pages/manual/Timekeeping-Regulation.vue"
  );
const MyNextpay = () =>
  import(/* webpackChunkName: "common-page" */ "@/pages/manual/MyNextpay.vue");
const MyNPManual = () =>
  import(
    /* webpackChunkName: "common-page" */ "@/pages/manual/mynextpay-manual.vue"
  );

// KH tiềm năng
const potentialCustomers = () =>
  import(
    /* webpackChunkName: "potential-page" */ "@/pages/potential_customers/list-potential-customers"
  );
const detailPotentialCustomers = () =>
  import(
    /* webpackChunkName: "potential-page" */ "@/pages/potential_customers/detail-potential-customers"
  );
const editPotentialCustomers = () =>
  import(
    /* webpackChunkName: "potential-page" */ "@/pages/potential_customers/edit-potential-customers"
  );

const ticket = () =>
  import(/* webpackChunkName: "ticket-page" */ "@/pages/ticket/index.vue");
const ticketDetail = () =>
  import(/* webpackChunkName: "ticket-page" */ "@/pages/ticket/detail.vue");
const ticketWork = () =>
  import(/* webpackChunkName: "ticket-page" */ "@/pages/ticket/work.vue");
const ticketRequest = () =>
  import(/* webpackChunkName: "ticket-page" */ "@/pages/ticket/request.vue");
const ticketImport = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/import-ticket.vue"
  );
const ticketGroup = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-group/index.vue"
  );
const ticketGroupRequest = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-group/request.vue"
  );
const ticketCategory = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-category/index.vue"
  );
const ticketCategoryRequest = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-category/request.vue"
  );
const ticketSubCategory = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-sub-category/index.vue"
  );
const ticketSubCategoryRequest = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-sub-category/request.vue"
  );
const ticketConfigWorkflow = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-category/config-workflow.vue"
  );
const ticketHistory = () =>
  import(/* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-history");
const ticketEditManage = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/edit-manage-info.vue"
  );
const ticketCurrentState = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-current-state/index.vue"
  );
const ticketCurrentStateRequest = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/ticket-current-state/request.vue"
  );
const ticketTransition = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/transition/index.vue"
  );
const ticketTransitionRequest = () =>
  import(
    /* webpackChunkName: "ticket-page" */ "@/pages/ticket/transition/request.vue"
  );

// email gửi cho potential
const listEmail = () =>
  import(/* webpackChunkName: "potential-page" */ "@/pages/email/list.vue");
const PDFViewer = () =>
  import(
    /* webpackChunkName: "pdf-viewer" */ "@/pages/contract/review/PDFViewer/index.vue"
  );

// ghi nhận kpi
const kpiRecordList = () =>
  import(
    /* webpackChunkName: "kpi-reacord-list" */ "@/pages/kpi-record/list.vue"
  );
const kpiRecordDetail = () =>
  import(
    /* webpackChunkName: "kpi-reacord-detail" */ "@/pages/kpi-record/detail.vue"
  );
const kpiRecordUpload = () =>
  import(
    /* webpackChunkName: "kpi-reacord-add" */ "@/pages/kpi-record/upload.vue"
  );
const kpiRecordUploadDetail = () =>
  import(
    /* webpackChunkName: "kpi-reacord-edit" */ "@/pages/kpi-record/uploadDetail.vue"
  );
const kpiRecordUploadHistory = () =>
  import(
    /* webpackChunkName: "kpi-reacord-edit" */ "@/pages/kpi-record/uploadHistory.vue"
  );

//Call IO
const listCallIo = () =>
  import(/* webpackChunkName: "call-io-page" */ "@/pages/call-io/index.vue");
const detailCallIo = () =>
  import(/* webpackChunkName: "call-io-page" */ "@/pages/call-io/detail.vue");

//Điều chỉnh số lượng vật tư
const listQuantityMaterial = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/quantityMaterial/index.vue"
  );
const requestQuantityMaterial = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/quantityMaterial/request.vue"
  );
const detailQuantityMaterial = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/pages/device/quantityMaterial/detail.vue"
  );

//Data SMS
const dataSms = () =>
  import(/* webpackChunkName: "data-sms" */ "@/pages/data-sms/index.vue");

//Report Inventory
const reportInventory = () =>
  import(
    /* webpackChunkName: "data-sms" */ "@/pages/device/reportInventory/index.vue"
  );

// Tinh KPI ban hang
const kpiConfigList = () =>
  import(
    /* webpackChunkName: "kpi-sale/config/list" */ "@/pages/kpi-sale/config/list.vue"
  );
const kpiConfigDetail = () =>
  import(
    /* webpackChunkName: "kpi-sale/config/list" */ "@/pages/kpi-sale/config/detail.vue"
  );
const kpiOrderGetList = () =>
  import(
    /* webpackChunkName: "kpi-sale/kpi-order-get-list" */ "@/pages/kpi-sale/order/list.vue"
  );
// const kpiOrderItemDetail = () =>  import(/* webpackChunkName: "kpi-sale/kpi-order-item-detail" */ '@/pages/kpi-sale/order/detailV2.vue')
const kpiOrderItemDetail = () =>
  import(
    /* webpackChunkName: "kpi-sale/kpi-order-item-detail" */ "@/pages/kpi-sale/order/detail.vue"
  );
const kpiOrderTamTinh = () =>
  import(
    /* webpackChunkName: "kpi-sale/kpi-order-tam-tinh" */ "@/pages/kpi-sale/order/temp.vue"
  );
// Chính sách thiết bị
const policyDevice = () =>
  import(/* webpackChunkName: "data-sms" */ "@/pages/policy-device/index.vue");
const requestPolicyDevice = () =>
  import(
    /* webpackChunkName: "data-sms" */ "@/pages/policy-device/request.vue"
  );
const detailPolicyDevice = () =>
  import(/* webpackChunkName: "data-sms" */ "@/pages/policy-device/detail.vue");

//Thong báo hệ thống
const listNotificationSystem = () =>
  import(
    /* webpackChunkName: "data-sms" */ "@/pages/system-notification/index.vue"
  );
const requestNotificationSystem = () =>
  import(
    /* webpackChunkName: "data-sms" */ "@/pages/system-notification/request.vue"
  );
const detailNotificationSystem = () =>
  import(
    /* webpackChunkName: "data-sms" */ "@/pages/system-notification/detail.vue"
  );

//Danh sách phiếu chuyển test
const usageChange = () =>
  import(
    /* webpackChunkName: "data-sms" */ "@/pages/device/usageChange/index.vue"
  );
const requestUsageChange = () =>
  import(
    /* webpackChunkName: "data-sms" */ "@/pages/device/usageChange/request.vue"
  );
const detailUsageChange = () =>
  import(
    /* webpackChunkName: "data-sms" */ "@/pages/device/usageChange/detail.vue"
  );

//TPV
const listTPV = () =>
  import(/* webpackChunkName: "data-sms" */ "@/pages/tpv/index.vue");
const detailTPV = () =>
  import(/* webpackChunkName: "data-sms" */ "@/pages/tpv/detail.vue");

const cameraTest = () =>
  import(
    /* webpackChunkName: "warehouse-page" */ "@/components/CameraSite.vue"
  );

//TPV Merchant
const tpvMerchant = () =>
  import(/* webpackChunkName: "data-sms" */ "@/pages/tpv-merchant/index.vue");
const tpvMerchantT7 = () =>
  import(/* webpackChunkName: "data-sms" */ "@/pages/tpv-merchant/indexT7.vue");
// const tpvMa =() => import(/* webpackChunkName: "data-sms" */ '@/pages/tpv/tpv-ma.vue')


export const routes = [
  {
    path: "/",
    name: "index",
    component: homePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | home` },
  },
  {
    path: "/403",
    name: "403",
    component: Unauthorized,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | 403`, layout: "login" },
  },
   {
    path: "/customer-support/task-type-purpose",
    name: "TaskListPurpose",
    component: () => import("@/pages/customer-support/cskh/task/ListTypePurpose.vue"),
    meta: { isAuth: true, title: `Công việc  | ${DOMAIN_TITLE}` },
  },
  {
    path: "/sso/auth",
    name: "SSO_AUTH",
    component: ssoAuthPage,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | login`, layout: "login" },
  },
  {
    path: "/login",
    name: "login",
    component: loginPage,
    meta: { title: `${DOMAIN_TITLE} | login`, layout: "login" },
  },
  {
    path: "/authorize",
    name: "Authorize",
    component: authorize,
    meta: { isAuth: false, title: `${DOMAIN_TITLE}`, layout: "login" },
  },
  {
    path: "/viewer/pdf",
    name: "PDFViewer",
    component: PDFViewer,
    meta: { isAuth: false, title: `${DOMAIN_TITLE}`, layout: "login" },
  },
  {
    path: "*",
    component: notFoundPage,
    meta: { title: `${DOMAIN_TITLE} | not found` },
  },

  {
    path: "/default",
    component: DefaultPage,
    name: "Default",
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} | default`,
      layout: "login",
    },
  },
  {
    path: "/change-pass",
    name: "changePass",
    component: changePassword,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thay đổi mật khẩu` },
  },
  {
    path: "/policy",
    name: "Policy",
    component: policy,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | Policy`, layout: "login" },
  },
  {
    path: "/menu",
    component: menu,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Menu` },
  },
  // lịch làm việc
  {
    path: "/calendar",
    component: calendar,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lich làm việc` },
  },
  {
    path: "/calendar/add",
    component: calendarRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới lịch làm việc` },
  },
  {
    path: "/calendar-edit/:id",
    component: calendarRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa lịch làm việc` },
  },
  {
    path: "/calendar/detail",
    component: calendarDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết lịch làm việc` },
  },
  {
    path: "/calendar-import-file",
    component: calendarImportExcel,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Nhập file Excel lịch làm việc`,
    },
  },
  {
    path: "/calendar-import-excel-err",
    component: calendarImportExcelError,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Nhập file Excel lỗi` },
  },
  {
    path: "/update-work/:id",
    component: updateWork,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật công việc` },
  },
  // lịch làm việc AFS
  {
    path: "/group-calendar-afs",
    name: "groupCalendarAFS",
    component: groupCalendarAFS,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Nhóm công việc AFS` },
  },
  {
    path: "/group-calendar-afs-add",
    name: "groupCalendarAFSAdd",
    component: groupCalendarAFSAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm nhóm công việc AFS` },
  },
  {
    path: "/group-calendar-afs/:id",
    name: "groupCalendarAFSDetail",
    component: groupCalendarAFSDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết nhóm công việc AFS`,
    },
  },
  {
    path: "/group-calendar-afs/edit/:id",
    name: "groupCalendarAFSEdit",
    component: groupCalendarAFSEdit,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chỉnh sửa nhóm công việc AFS`,
    },
  },
  {
    path: "/group-calendar-afs-import",
    name: "groupCalendarAFSImport",
    component: groupCalendarAFSImport,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Import nhóm công việc AFS`,
    },
  },
  {
    path: "/import-group-calendar-err",
    name: "importGroupCalendarError",
    component: importGroupCalendarError,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm nhóm công việc AFS từ file lỗi`,
    },
  },
  {
    path: "/import-group-calendar-success",
    name: "importGroupCalendarSuccess",
    component: importGroupCalendarSuccess,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm nhóm công việc từ file thành công `,
    },
  },
  {
    path: "/cat-calendar-afs",
    name: "catCalendarAFS",
    component: catCalendarAFS,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh mục công việc AFS` },
  },
  {
    path: "/cat-calendar-afs/detail/:id",
    name: "catCalendarAFSDetail",
    component: catCalendarAFSDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết danh mục công việc`,
    },
  },
  {
    path: "/cat-calendar-afs-add",
    name: "catCalendarAFSAdd",
    component: catCalendarAFSAdd,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm danh mục công việc AFS`,
    },
  },
  {
    path: "/cat-calendar-afs/:id",
    name: "catCalendarAFSEdit",
    component: catCalendarAFSEdit,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chỉnh sửa danh mục công việc`,
    },
  },
  {
    path: "/cat-calendar-afs-import",
    name: "cat-calendarAFSImport",
    component: catCalendarAFSImport,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Import danh mục công việc AFS`,
    },
  },
  {
    path: "/import-cat-calendar-err",
    name: "importCatCalendarError",
    component: importCatCalendarError,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm danh mục công việc AFS từ file lỗi`,
    },
  },
  {
    path: "/import-cat-calendar-success",
    name: "importCatCalendarSuccess",
    component: importCatCalendarSuccess,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm danh mục công việc từ file thành công `,
    },
  },
  {
    path: "/sticker-standee",
    name: "stickerStandee",
    redirect: "/sticker-standee/sale",
  },
  {
    path: "/sticker-standee/:job",
    name: "stickerStandeeJob",
    component: stickerStandee,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | công việc dán Sticker-Standee`,
    },
  },
  {
    path: "/sticker-standee/sale/:id",
    name: "stickerStandeeSaleDetail",
    component: stickerStandeeSaleDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết công việc của Sale`,
    },
  },
  {
    path: "/sticker-standee/afs/:id",
    name: "stickerStandeeAfsDetail",
    component: stickerStandeeAfsDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết công việc của AFS`,
    },
  },
  {
    path: "/sticker-standee/cskh/:id",
    name: "stickerStandeeCskhDetail",
    component: () => import("@/pages/sticker-standee/cskh-detail.vue"),
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết công việc của CSKH`,
    },
  },

  {
    path: '/customer-support/device-store',
    name: 'OrderContract',
    component: () => import('@/pages/customer-support/cskh/device-store/list.vue'),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Quản lý trạng thái sử dụng thiết bị` }
  },
  {
    path: '/customer-support/device-store/:id',
    name: 'OrderContractDetail',
    component: () => import('@/pages/customer-support/cskh/device-store/detail.vue'),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết trạng thái sử dụng thiết bị ` }
  },

  {
    path: '/customer-support/order-contract',
    name: 'OrderContract',
    component: () => import('@/pages/customer-support/cskh/order-contract/list.vue'),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu luân chuyển thiết bị ` }
  },
  {
    path: '/customer-support/order-contract/:id',
    name: 'OrderContractDetail',
    component: () => import('@/pages/customer-support/cskh/order-contract/detail.vue'),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết phiếu luân chuyển thiết bị ` }
  },

  {
    path: "/file",
    name: "File",
    component: File,
  },
  {
    path: "/file/detail/:id",
    name: "FileDetail",
    component: FileDetail,
  },
  {
    path: "/file/import",
    name: "FileImport",
    component: FileImport,
  },
  {
    path: "/gpdkkd",
    name: "GPDKKD",
    redirect: "/gpdkkd/mc",
  },
  {
    path: "/gpdkkd/zip-file",
    name: "GPDKKDzip-file",
    component: GPDKKDZipFile,
  },
  {
    path: "/gpdkkd/:job",
    name: "GPDKKDJob",
    component: GPDKKD,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | công việc dán gpdkkd` },
  },
  {
    path: "/gpdkkd/sale/:id",
    name: "GPDKKDSaleDetail",
    component: GPDKKDSaleDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết công việc của Sale`,
    },
  },
  {
    path: "/gpdkkd/afs/:id",
    name: "GPDKKDAfsDetail",
    component: GPDKKDAfsDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết công việc của AFS`,
    },
  },
  {
    path: "/calendar-afs",
    name: "calendarAFS",
    component: calendarAFS,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Công việc AFS` },
  },
  {
    path: "/calendar-afs/create",
    name: "calendarAFSAdd",
    component: calendarAFSRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm công việc AFS` },
  },
   {
    path: "/create-combo-contract",
    name: "createComboContract",
    component: createComboContact,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới combo bán hàng` },
  },
  {
    path: "/calendar-afs/edit/:id",
    name: "calendarAFSEdit",
    component: calendarAFSRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật công việc AFS` },
  },
  {
    path: "/calendar-afs/detail/:id",
    name: "calendarAFSDetail",
    component: calendarAFSDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết công việc` },
  },
  // điểm danh và chấm công bổ sung
  {
    path: "/attendance",
    component: attendance,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} |  Điểm danh` },
  },
  {
    path: "/attendance/:userId/:time",
    component: attendanceDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} |  Chi tiết điểm danh ` },
  },
  {
    path: "/timekeeping",
    component: timekeeping,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} |  Chấm công bổ sung ` },
  },
  {
    path: "/timekeeping/:id",
    component: timekeepingDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} |  Chi tiết chấm công bổ sung `,
    },
  },
  {
    path: "/timekeeping-add",
    component: timekeepingAdd,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} |  Thêm mới chấm công bổ sung`,
    },
  },
  {
    path: "/timekeeping-edit/:id",
    component: timekeepingEdit,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} |  Sửa chấm công bổ sung` },
  },
  // merchant
  {
    path: "/list-mc",
    name: "listMC",
    component: listMC,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách Merchant` },
  },
  {
    path: "/list-mc-onboard",
    name: "listMCOnboard",
    component: listMCOnboard,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách Merchant tự onboard` },
  },
  {
    path: "/map-list-mc",
    name: "mapListMC",
    component: mapListMC,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách map Merchant` },
  },
  {
    path: "/heatmap-list-mc",
    name: "mapListMCV3",
    component: mapListMCV3,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Heatmap Merchants` },
  },
  {
    path: "/list-mc/:customerId",
    name: "merchantDetail",
    component: MerchantDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách Merchant` },
  },
  {
    path: "/merchant-add",
    name: "merchantAdd",
    component: MerchantAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm merchant` },
  },
  {
    path: "/merchant-edit/:customerId",
    name: "merchantEdit",
    component: MerchantEdit,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm merchant` },
  },
  {
    path: "/trans-mc",
    name: "transMC",
    component: transMC,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Điều chuyển Merchant` },
  },
  {
    path: "/history-trans",
    name: "historyTrans",
    component: historyTrans,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Lịch sử điều chuyển Merchant`,
    },
  },
  {
    path: "/history-trans/:transferId",
    name: "detailTrans",
    component: detailTrans,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết điều chuyển Merchant`,
    },
  },
  {
    path: "/list-mc-nextlend",
    name: "listMerchantNextlend",
    component: listMCNextlend,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách Merchant Nextlend`,
    },
  },
  {
    path: "/list-mc-nextlend/detail/:activeSaleEmail",
    name: "merchantNextlendDetail",
    component: mcNextlendDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết Merchant Nextlend`,
    },
  },
  {
    path: "/mc-landing",
    name: "merchantLanding",
    component: MCLanding,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách MC từ Landing` },
  },
  // Nextlend
  {
    path: "/customer-nextlend",
    name: "customerNextlend",
    component: customerNextlend,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | KH tiềm năng Nextlend` },
  },
  {
    path: "/equity-nextlend",
    name: "equityNextlend",
    component: equityNextlend,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách ứng vốn Nextlend`,
    },
  },

  // DEVICE LOCATION
  {
    path: "/device-location/list",
    name: "listDeviceLocation",
    component: listDeviceLocation,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách vị trí thiết bị`,
    },
  },
  {
    path: "/device-location/:id",
    name: "detailDeviceLocation",
    component: detailDeviceLocation,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | chi tiết vị trí thiết bị` },
  },

  // Quản lý CTV
  {
    path: "/list-agency",
    name: "manageAgencyList",
    component: ManagerAgencyList,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Quản lý đại lý`,
    },
  },

  {
    path: "/list-agency-add",
    name: "manageAgencyAdd",
    component: ManagerAgencyAdd,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} |  Thêm mới đại lý`,
    },
  },
  {
    path: "/list-agency-edit/:id",
    name: "manageAgencyEdit",
    component: ManagerAgencyAdd,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Cập nhật đại lý`,
    },
  },
  {
    path: "/list-agency-detail/:id",
    name: "manageAgencyDetail",
    component: ManagerAgencyDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} |  Chi tiết đại lý`,
    },
  },

   {
    path: "/list-agent-partner",
    name: "listAgentPartner",
    component: ListAgencyPartner,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách đối tác` },
  },

    {
    path: "/list-agent-partner-detail/:id",
    name: "listAgentPartnerDetail",
    component: ListAgencyPartnerDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết đối tác` },
  },
    {
    path: "/list-agent-partner-edit/:id",
    name: "listAgentPartnerEdit",
    component: ListAgencyPartnerEdit,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa thông tin đối tác` },
  },
  {
    path: "/list-tingbox-ctv",
    name: "listTingboxCtv",
    component: listTingboxCtv,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách hoa hồng tingbox ctv` },
  },
  {
    path: "/list-tingbox-ctv/:id",
    name: "DetailTingboxCtv",
    component: DetailTingboxCtv,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết hoa hồng tingbox ctv` },
  },
  {
    path: "/list-collaborators",
    name: "listCollaborators",
    component: listCollaborators,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách cộng tác viên` },
  },
  {
    path: "/import-collaborators",
    name: "importCollaborator",
    component: importCollaborator,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Nhập file cộng tác viên` },
  },
  {
    path: "/list-collaborators/:agentId",
    name: "collaboratorDetail",
    component: collaboratorDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết cộng tác viên` },
  },
  {
    path: "/manage-mc",
    name: "manageMC",
    component: manageMC,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Quản lý merchant` },
  },
  {
    path: "/assign-mc/:customerId",
    name: "manageMCDetail",
    component: manageMCDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Quản lý merchant` },
  },
  {
    path: "/assign-mc",
    name: "assginMC",
    component: assignMC,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Gán merchant` },
  },
  {
    path: "/history-assign-mc",
    name: "historyAssignMC",
    component: historyAssignMC,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lịch sử gán merchant` },
  },
  // Nhân viên
  {
    path: "/staff",
    name: "staff",
    component: staff,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Quản lý nhân viên` },
  },
  {
    path: "/staff-add",
    name: "staffAdd",
    component: staffAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới nhân viên` },
  },
  {
    path: "/staff/detail",
    name: "staffDetail",
    component: staffDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết nhân viên` },
  },
  {
    path: "/staff-import-step-one",
    component: importStaffOne,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Import danh sách nhân viên step 1 `,
    },
  },
  {
    path: "/staff-import-step-two",
    component: importStaffTwo,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} |  Import danh sách nhân viên step 2 `,
    },
  },
  {
    path: "/staff-import-step-final",
    component: importStaffFinal,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} |  Import danh sách nhân viên final `,
    },
  },
  {
    path: "/staff-edit",
    name: "reviewEdit",
    component: staffEdit,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa nhân viên` },
  },
  // báo cáo
  {
    path: "/report-device-contract",
    name: "reportDeviceContract",
    component: reportDeviceContract,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Báo cáo danh sách thiết bị lên hợp đồng`,
    },
  },
  {
    path: "/report-device",
    name: "reportDevice",
    component: reportDevice,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Báo cáo danh sách thiết bị đã lên hợp đồng`,
    },
  },
  {
    path: "/report-attentdent",
    name: "reportAttentdent",
    component: reportAttentdent,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Báo cáo chấm công` },
  },
  {
    path: "/report-merchant",
    name: "reportMerchant",
    component: reportMerchant,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Báo cáo khách hàng` },
  },
  {
    path: "/report-work",
    name: "reportWork",
    component: reportWork,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Báo cáo công việc` },
  },
  {
    path: "/report-work-cvkd",
    name: "reportWorkCVKD",
    component: reportWorkCVKD,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Báo cáo công việc của CVKD`,
    },
  },
  // hợp đồng
  {
    path: "/preview-contract-ctv",
    name: "tempCTV",
    component: TempCTV,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Hợp đồng Merchant CTV`,
      layout: "login",
    },
  },
  {
    path: "/middleware-pdf",
    component: middlewarePdf,
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} |  Middleware pdf`,
      layout: "login",
    },
  },
  {
    path: "/contract-review/:contractId",
    component: ReviewContract,
    meta: {
      title: `${DOMAIN_TITLE} | Chi tiết hợp đồng điện tử`,
      layout: "login",
    },
  },
  {
    path: "/preview-appendix/:contractID/:appendixId",
    component: ReviewApendixContract,
    meta: {
      title: `${DOMAIN_TITLE} | Chi tiết hợp đồng điện tử `,
      layout: "login",
    },
  },
 {
    path: "/contract-detail-ecommerce/:id",
    name: "contractDetailEcommerce",
    component: contractDetailEcommerce,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết hợp đồng điện tử `,
    },
  },
  {
    path: "/contract-megabiz",
    name: "contracMagabiz",
    component: contracMagabiz,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách hợp đồng điện tử `,
    },
  },
  {
    path: "/contract-detail/history-action-details",
    name: "historyActionDetails",
    component: historyActionDetails,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết điều chỉnh` },
  },
  {
    path: "/contract-detail-paper/:id",
    name: "contractDetailPaper",
    component: contractDetailPaper,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết hợp đồng giấy ` },
  },
  {
    path: "/reviewHDDT",
    name: "reviewHDDT",
    component: ReviewContract,
    meta: {
      title: `${DOMAIN_TITLE} | Preview`,
      layout: "login",
      isAuth: false,
    },
  },
  {
    path: "/posapp",
    name: "posapp",
    component: Posapp,
    meta: {
      title: `${DOMAIN_TITLE} | posapp`,
      layout: "login",
      isAuth: false,
    },
  },
  {
    path: "/HDDT-email",
    name: "HDDTemail",
    component: ReviewEmailContract,
    meta: { title: `${DOMAIN_TITLE} | Review`, layout: "login", isAuth: false },
  },
  {
    path: "/review-email-apendix",
    name: "apendix email",
    component: ReviewApendixEmailContract,
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} | Xác nhận phụ lục hợp đồng`,
      layout: "login",
    },
  },
  {
    path: "/appendix-manager",
    name: "appendixManager",
    component: appendixManager,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Quản lý phụ lục hợp đồng ký thêm`,
    },
  },
  {
    path: "/contract-manager",
    name: "contractManager",
    component: contractManager,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Quản lý hợp đồng` },
  },
  {
    path: "/sales-manager/detail/:id",
    name: "Quản lý bán hàng chi tiết",
    component: qlbhDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết bán hàng` },
  },
  {
    path: "/sales-manager/detail-paper/:id",
    name: "Quản lý bán hàng chi tiết ",
    component: salesManagerPaperDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết bán hàng HDG` },
  },
  {
    path: "/approve-update/:contractId",
    name: "Duyệt chỉnh sửa hợp đồng",
    component: approveUpdate,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Duyệt chỉnh sửa hợp đồng` },
  },
  {
    path: "/history-approve-update/:reqId",
    name: "Lịch sử chỉnh sửa hợp đồng",
    component: historyUpdate,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Lịch sử chỉnh sửa hợp đồng`,
    },
  },
  {
    path: "/appendix-fee-visa",
    name: "appendixFeeVisa",
    component: appendixFeeVisa,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Quản lý phụ lục phí Visa` },
  },
  {
    path: "/info-change",
    name: "listInfoChange",
    component: listInfoChange,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách yêu cầu thay đổi thông tin`,
    },
  },
  {
    path: "/info-change/:id",
    name: "detailInfoChange",
    component: detailInfoChange,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết yêu cầu thay đổi thông tin`,
    },
  },
  {
    path: "/mc-bidv",
    name: "listMcBIDV",
    component: listMcBIDV,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách đối soát MC ưu đãi khi mở BIDV`,
    },
  },
  {
    path: "/proposed-fees",
    name: "lisProposedFees",
    component: listPrpopsed,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách đối soát MC ưu đãi khi mở BIDV`,
    },
  },
   {
    path: "/request-sales-combo",
    name: "requestSalesCombo",
    component: requestSalesCombo,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Yêu cầu combo bán hàng`,
    },
  },
   {
    path: "/request-sales-combo-detail/:id",
    name: "requestSalesComboDetail",
    component: requestSalesComboDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết yêu cầu combo bán hàng`,
    },
  },
  // Quản lý agent
  {
    path: "/agent",
    component: agent,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} |  Danh sách Agent ` },
  },
  {
    path: "/agent/create",
    component: agentCreate,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} |  Thêm mới Agent ` },
  },
  {
    path: "/agent/update/:id",
    component: agentUpdate,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} |  Cập nhập Agent ` },
  },
  {
    path: "/agent/:id",
    component: agentDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} |  Chi tiết Agent ` },
  },

  // cài đặt
  {
    path: "/role",
    name: "role",
    component: role,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Quản lý phân quyền` },
  },
  {
    path: "/role-add",
    name: "roleAdd",
    component: roleAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới quyền` },
  },
  {
    path: "/role-edit/:id",
    name: "roleEdit",
    component: roleEdit,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật quyền` },
  },
  // tracking
  {
    path: "/tracking",
    name: "tracking",
    component: tracking,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tracking` },
  },
  {
    path: "/tracking/detail",
    name: "trackingDetail",
    component: trackingDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tracking` },
  },

  // Link cho app
  {
    path: "/intro-ctv",
    name: "IntroCTVPage",
    component: IntroCTVPage,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | Ads`, layout: "login" },
  },
  {
    path: "/privacy-nextagent",
    name: "PrivacyNextAgent",
    component: PrivacyNextAgent,
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} | Privacy Policy`,
      layout: "login",
    },
  },

  // Phieu thu
  {
    path: "/list-receipts",
    name: "listReceipts",
    component: listReceipts,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu thu` },
  },
  {
    path: "/history-receipts",
    name: "historyReceipts",
    component: historyReceipts,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lịch sử upload file` },
  },
  {
    path: "/download-receipts/:key",
    name: "downloadFile",
    component: downloadFile,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tải xuống ds phiếu thu` },
  },
  {
    path: "/detail-receipts/:receiptId",
    name: "detailReceipts",
    component: detailReceipts,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết phiếu thu` },
  },
  {
    path: "/edit-receipts/:receiptId/:checkFrom",
    name: "editReceipts",
    component: editReceipts,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa phiếu thu` },
  },
  {
    path: "/add-receipts",
    name: "addReceipts",
    component: addReceipts,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới phiếu thu` },
  },
  {
    path: "/compare-import",
    name: "compareFile",
    component: compareFile,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách đối soát` },
  },
  // Hoàn tiền phiếu thu
  {
    path: "/list-refund",
    name: "listRefund",
    component: listRefund,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách hoàn tiền phiếu thu`,
    },
  },
  {
    path: "/list-refund/:id",
    name: "detailRefund",
    component: detailRefund,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết hoàn tiền phiếu thu`,
    },
  },
  // yêu cầu thanh toán listOrder
  {
    path: "/list-order",
    name: "listOrder",
    component: listOrder,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách phiếu yêu cầu thanh toán`,
    },
  },
  {
    path: "/list-order/:id",
    name: "detailOrder",
    component: detailOrder,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết phiếu yêu cầu thanh toán`,
    },
  },
  // Leads
  {
    path: "/leads",
    name: "listLeads",
    component: listLeads,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách leads` },
  },
  {
    path: "/add-lead",
    name: "addLead",
    component: addLead,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới Lead` },
  },
  {
    path: "/detail-lead/:leadId/:action",
    name: "detailLead",
    component: detailLead,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết Lead` },
  },
  {
    path: "/edit-lead/:leadId",
    name: "editLead",
    component: editLead,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa Lead` },
  },
  {
    path: "/auth-info/:leadId/:auth",
    name: "authLead",
    component: authLead,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chuyển thành khách hàng` },
  },
  {
    path: "/import-file-lead",
    name: "importLead",
    component: importLead,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm Leads từ file` },
  },
  {
    path: "/import-file-lead-err",
    name: "importLeadErr",
    component: importLeadErr,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm Leads từ file lỗi` },
  },
  {
    path: "/import-file-lead-success",
    name: "importLeadSuccess",
    component: importLeadSuccess,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm Leads từ file thành công `,
    },
  },

  // Giam sat / Lich su duyet chi hoa hong
  {
    path: "/history-comissions",
    name: "historyComissions",
    component: historyComissions,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lịch sử chi hoa hồng` },
  },
  // quan ly thiet bi
  {
    path: "/device",
    name: "listDevice",
    component: listDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách Thiết bị` },
  },
  {
    path: "/device/:id",
    name: "detailDevice",
    component: detailDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết Thiết bị` },
  },
  {
    path: "/edit-device/:leadId",
    name: "editDevice",
    component: editDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa Thiết bị` },
  },
  {
    path: "/cat-device",
    name: "catDevice",
    component: catDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh mục Thiết bị` },
  },
  {
    path: "/attached-sim",
    name: "AttachedSim",
    component: AttachedSim,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sim kèm tingbox` },
  },
  {
    path: "/add-cat-device",
    name: "addCatDevice",
    component: addCatDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mục Thiết bị` },
  },
  {
    path: "/cat-device/edit/:id",
    name: "editCatDevice",
    component: editCatDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa danh mục Thiết bị` },
  },
  {
    path: "/cat-device/:id",
    name: "detailCatDevice",
    component: detailCatDevice,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết danh mục Thiết bị`,
    },
  },
  {
    path: "/equipment-handover-confirmation",
    name: "Xác nhận bàn giao thiết bị",
    component: equipmentHandoverConfirmation,
    meta: {
      title: `${DOMAIN_TITLE} | Xác nhận bàn giao thiết bị`,
      layout: "login",
      isAuth: false,
    },
  },
  {
    path: "/equipment-handover-list/",
    name: "Danh sách bàn giao thiết bị",
    component: equipmentHandoverList,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách bàn giao thiết bị`,
    },
  },
  {
    path: "/warranty",
    name: "Danh sách phiếu bảo hành",
    component: listWarranty,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu bảo hành` },
  },
  {
    path: "/agent-receipt",
    name: "listAgentReceipt",
    component: listAgentReceipt,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu thu đại lý` },
  },
  {
    path: "/agent-receipt-detail/:entryId",
    name: "DetailAgentReceipt",
    component: detailAgentReceipt,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết phiếu thu đại lý` },
  },
  {
    path: "/agent-receipt-add",
    name: "addAgentReceipt",
    component: addAgentReceipt,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm phiếu thu đại lý` },
  },
  {
    path: "/agent-receipt-edit/:entryId",
    name: "addAgentReceipt",
    component: addAgentReceipt,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật phiếu thu đại lý` },
  },
  {
    path: "/warranty/create",
    name: "Tạo mới phiếu bảo hành",
    component: warrantyRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo mới phiếu bảo hành` },
  },
  {
    path: "/warranty/edit/:id",
    name: "Sửa phiếu bảo hành",
    component: warrantyRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa phiếu bảo hành` },
  },
  {
    path: "/warranty/:id",
    name: "Chi tiết phiếu bảo hành",
    component: warrantyDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết phiếu bảo hành` },
  },
  {
    path: "/warranty/active/:id",
    name: "Ghi nhận hoạt động bảo hành",
    component: warrantyRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết phiếu bảo hành` },
  },
  {
    path: "/error-type",
    name: "Danh sách loại lỗi",
    component: listErrorType,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách loại lỗi` },
  },
  {
    path: "/error-type/create",
    name: "Thêm mới loại lỗi",
    component: errorTypeRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới loại lỗi` },
  },
  {
    path: "/error-type/:id",
    name: "Sửa loại lỗi",
    component: errorTypeRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa loại lỗi` },
  },
  {
    path: "/material/list/status",
    name: "Danh sách vật tư theo trạng thái",
    component: listMaterialStatus,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách vật tư theo trạng thái`,
    },
  },
  {
    path: "/material/list/warehouse",
    name: "Danh sách vật tư theo kho",
    component: listMaterialWarehourse,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách vật tư theo kho`,
    },
  },
  {
    path: "/material/:type/:id",
    name: "Chi tiết vật tư",
    component: detailMaterial,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết vật tư` },
  },

  // Quan ly nhap kho
  {
    path: "/import-warehouse",
    name: "listImportWarehouse",
    component: listImportWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu nhập kho` },
  },
  {
    path: "/import-warehouse/add",
    name: "addImportWarehouse",
    component: addImportWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm phiếu nhập kho` },
  },
  {
    path: "/import-warehouse/edit/:entryId",
    name: "editImportWarehouse",
    component: addImportWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa phiếu nhập kho` },
  },
  {
    path: "/import-warehouse/detail/:entryId",
    name: "detaiImportWarehouse",
    component: detaiImportWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết phiếu nhập kho` },
  },

  // Quan ly chuyen kho

  {
    path: "/transfer-agency",
    name: "transferAgencyList",
    component: listTransferAgency,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách phiếu điều chuyển đại lý`,
    },
  },
  {
    path: "/transfer-agency-detail/:entryId",
    name: "transferAgencyDetail",
    component: transferAgencyDetail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết phiếu điều chuyển đại lý`,
    },
  },
  {
    path: "/transfer-warehouse",
    name: "listTransferWarehouse",
    component: listTransferWarehouse,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách phiếu điều chuyển`,
    },
  },
  {
    path: "/transfer-warehouse/add",
    name: "addTransferWarehouse",
    component: addTransferWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm phiếu điều chuyển` },
  },
  {
    path: "/transfer-warehouse/edit/:entryId",
    name: "editTransferWarehouse",
    component: addTransferWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa phiếu điều chuyển` },
  },
  {
    path: "/transfer-warehouse/detail/:entryId",
    name: "detaiTransferWarehouse",
    component: detaiTransferWarehouse,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết phiếu điều chuyển`,
    },
  },
  {
    path: "/transfer-warehouse/approve-export/:entryId",
    name: "approveExportTransferWarehouse",
    component: approveExportTransferWarehouse,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Xác nhận điều chuyển thiết bị`,
    },
  },
  {
    path: "/transfer-warehouse/approve-import/:entryId",
    name: "approveImportTransferWarehouse",
    component: approveImportTransferWarehouse,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Xác nhận điều chuyển thiết bị`,
    },
  },

  // Quan ly xuat kho
  {
    path: "/export-warehouse",
    name: "exportWarehouse",
    component: exportWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu xuất kho` },
  },
  {
    path: "/export-warehouse/:id",
    name: "detailExportWarehouse",
    component: detailExportWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết phiếu xuất kho` },
  },

  // Danh muc kho
  {
    path: "/cat-warehouse",
    name: "listCatWarehouse",
    component: listCatWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách kho` },
  },
  {
    path: "/cat-warehouse/:id",
    name: "detailCatWarehouse",
    component: detailCatWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết kho` },
  },
  {
    path: "/cat-warehouse-add",
    name: "addCatWarehouse",
    component: addCatWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới kho` },
  },
  {
    path: "/cat-warehouse-add-agency",
    name: "addCatWarehouseAgency",
    component: addCatWarehouseAgency,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới kho đại lý` },
  },
  {
    path: "/cat-warehouse/edit/:warehouseId",
    name: "editCatWarehouse",
    component: editCatWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa kho` },
  },
  {
    path: "/cat-warehouse/edit-employee/:warehouseId",
    name: "editCatWarehouseEmployee",
    component: editEmployeeCatWarehouse,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa kho` },
  },

  // Cau hinh gia goi dich vu thiet bi
  {
    path: "/device-service-price-config",
    name: "listDeviceServicePriceConfig",
    component: listDeviceServicePriceConfig,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách cấu hình Giá gói dịch vụ / Thiết bị`,
    },
  },
  {
    path: "/add-device-service-price-config",
    name: "addDeviceServicePriceConfig",
    component: addDeviceServicePriceConfig,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm cấu hình Giá gói dịch vụ / Thiết bị`,
    },
  },
  {
    path: "/edit-device-service-price-config/:id",
    name: "editDeviceServicePriceConfig",
    component: editDeviceServicePriceConfig,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Sửa cấu hình Giá gói dịch vụ / Thiết bị`,
    },
  },

  // HDSD
  {
    path: "/timekeeping-regulation",
    name: "regulation",
    component: TimekeepingRegulation,
    meta: {
      isAuth: false,
      layout: "login",
      title: `${DOMAIN_TITLE} | Quy định chấm công`,
    },
  },
  {
    path: "/mynextpay",
    name: "mynextpay",
    component: MyNextpay,
    meta: {
      isAuth: false,
      layout: "login",
      title: `${DOMAIN_TITLE} | My Nextpay`,
    },
  },
  {
    path: "/mynextpay-manual",
    name: "manual",
    component: MyNPManual,
    meta: {
      isAuth: false,
      layout: "login",
      title: `${DOMAIN_TITLE} | Hướng dẫn sử dụng My Nextpay`,
    },
  },

  // KH tiềm năng
  {
    path: "/potential-customers",
    name: "potentialCustomers",
    component: potentialCustomers,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách Khách hàng tiềm năng`,
    },
  },
  {
    path: "/detail-potential-customers/:customerId",
    name: "detailPotentialCustomers",
    component: detailPotentialCustomers,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết Khách hàng tiềm năng`,
    },
  },
  {
    path: "/edit-potential-customers/:customerId",
    name: "editPotentialCustomers",
    component: editPotentialCustomers,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa Khách hàng tiềm năng` },
  },

  // Chứng từ
  {
    path: "/list-licence",
    name: "listLicence",
    component: listLicence,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Yêu cầu chứng từ` },
  },
  {
    path: "/list-licence/:id",
    name: "detailLicence",
    component: detailLicence,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết yêu cầu chứng từ`,
    },
  },

  // T+2
  {
    path: "/payment-T2",
    name: "paymentT2",
    component: paymentT2,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thanh toán T+2` },
  },
  {
    path: "/payment-T2/:id",
    name: "detailPaymentT2",
    component: detailPaymentT2,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết thanh toán T+2` },
  },

  // MERCHANT UPLOAD CHỨNG TỪ
  {
    path: "/mc-ccct/list",
    name: "mcCcct",
    component: mcCcctLs,
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} | Merchant upload chứng từ`,
      layout: "login",
    },
  },
  {
    path: "/mc-ccct/:licenceId",
    name: "mcCcctDetail",
    component: mcCcct,
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} | Merchant upload chứng từ`,
      layout: "login",
    },
  },
  {
    path: "/self-service/mc-ccct/:processId",
    name: "mcCcctJoget",
    component: mcCcctJoget,
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} | Merchant upload chứng từ`,
      layout: "login",
    },
  },
  // MERCHANT UPLOAD GPDKKD
  {
    path: "/mc-dkkd/:stickerId",
    name: "mcDkkd",
    component: mcDkkd,
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} | Merchant upload giấy phép đăng ký kinh doanh`,
      layout: "login",
    },
  },

  // DANH SÁCH EMAIL GỬI CHO MC
  {
    path: "/list-email",
    name: "listEmail",
    component: listEmail,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách email gửi cho merchant`,
    },
  },
  // Ticket
  {
    path: "/ticket",
    name: "Ticket",
    component: ticket,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách ticket` },
  },
  {
    path: "/ticket/create",
    name: "ticketCreate",
    component: ticketRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo mới ticket` },
  },
  {
    path: "/ticket/edit/:id",
    name: "ticketEdit",
    component: ticketRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật ticket` },
  },
  {
    path: "/ticket/import-ticket",
    name: "ticketImport",
    component: ticketImport,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Nhập file Excel ticket` },
  },
  {
    path: "/ticket/:id",
    name: "TicketDetail",
    component: ticketDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết ticket` },
  },
  {
    path: "/ticket-work",
    name: "ticketWork",
    component: ticketWork,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách việc cần làm` },
  },
  {
    path: "/ticket-group",
    name: "TicketGroup",
    component: ticketGroup,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cấu hình nhóm ticket` },
  },
  {
    path: "/ticket-group/create",
    name: "TicketGroupCreate",
    component: ticketGroupRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo mới nhóm ticket` },
  },
  {
    path: "/ticket-group/edit/:id",
    name: "TicketGroupEdit",
    component: ticketGroupRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật nhóm ticket` },
  },
  {
    path: "/ticket-category",
    name: "TicketCategory",
    component: ticketCategory,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh mục ticket` },
  },
  {
    path: "/ticket-category/create",
    name: "TicketCategoryCreate",
    component: ticketCategoryRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo mới danh mục ticket` },
  },
  {
    path: "/ticket-category/edit/:id",
    name: "TicketCategoryEdit",
    component: ticketCategoryRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật danh mục ticket` },
  },
  {
    path: "/ticket-sub-category",
    name: "TicketSubCategory",
    component: ticketSubCategory,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tiểu mục ticket` },
  },
  {
    path: "/ticket-sub-category/create",
    name: "TicketSubCategoryCreate",
    component: ticketSubCategoryRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo mới tiểu mục ticket` },
  },
  {
    path: "/ticket-sub-category/edit/:id",
    name: "TicketSubCategoryUpdate",
    component: ticketSubCategoryRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật tiểu mục ticket` },
  },
  {
    path: "/ticket-category/config-workflow/:id",
    name: "ConfigWorkflow",
    component: ticketConfigWorkflow,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cấu hình workflow` },
  },
  {
    path: "/ticket-current-state",
    name: "ticketCurrentState",
    component: ticketCurrentState,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách hiện trạng ticket`,
    },
  },
  {
    path: "/ticket-current-state/create",
    name: "ticketCurrentStateCreate",
    component: ticketCurrentStateRequest,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm mới hiện trạng ticket`,
    },
  },
  {
    path: "/ticket-current-state/:id",
    name: "ticketCurrentStateEdit",
    component: ticketCurrentStateRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa hiện trạng ticket` },
  },
  {
    path: "/ticket-transition",
    name: "ticketTransition",
    component: ticketTransition,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách bước chuyển ticket`,
    },
  },
  {
    path: "/ticket-transition/create",
    name: "ticketTransitionCreate",
    component: ticketTransitionRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo bước chuyển ticket` },
  },
  {
    path: "/ticket-transition/:id",
    name: "ticketTransitionEdit",
    component: ticketTransitionRequest,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa bước chuyển ticket` },
  },
  // ghi nhận kpi
  {
    path: "/kpi-record/list",
    name: "kpi record list",
    component: kpiRecordList,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | kpi record list` },
  },
  {
    path: "/kpi-record/detail/:id",
    name: "kpi record detail",
    component: kpiRecordDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | kpi record detail` },
  },
  {
    path: "/kpi-record/upload/add",
    name: "kpi record upload add",
    component: kpiRecordUpload,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | kpi record upload add` },
  },
  {
    path: "/kpi-record/upload/history",
    name: "kpi record upload history",
    component: kpiRecordUploadHistory,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | kpi record upload history`,
    },
  },
  {
    path: "/kpi-record/upload/detail/:id",
    name: "kpi record upload detail",
    component: kpiRecordUploadDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | kpi record upload detail` },
  },
  {
    path: "/ticket-history",
    name: "TicketHistory",
    component: ticketHistory,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lịch sử hoạt động` },
  },
  {
    path: "/ticket-edit-manage/:id",
    name: "TicketEditManage",
    component: ticketEditManage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa TT quản lý` },
  },
  {
    path: "/customer-support/merchant-key",
    name: "MerchantKey",
    component: () => import("@/pages/customer-support/index.vue"),
    meta: { isAuth: true, title: `MerchantKey | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/filter-service",
    name: "FilterService",
    component: () => import("@/pages/customer-support/index.vue"),
    meta: { isAuth: true, title: `FilterService | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/tasks",
    name: "Tasks MCK",
    component: () => import("@/pages/customer-support/index.vue"),
    meta: { isAuth: true, title: `Công việc MCK | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/merchant-owner",
    name: "Quản lý khách hàng",
    component: () =>
      import("@/pages/customer-support/cskh/merchant-owner/listv3.vue"),
    // component: () => import('@/pages/customer-support/cskh/merchant-owner/list.vue'),
    meta: { isAuth: true, title: `Merchant owner | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/merchant-owner/:id",
    name: "Merchant Owner detail",
    component: () =>
      import("@/pages/customer-support/cskh/merchant-owner/detailv2.vue"),
    meta: { isAuth: true, title: `Merchant owner detail | ${DOMAIN_TITLE}` },
  },
  {
    path: '/customer-support/add-staff/:level',
    name: 'Gán nhân viên',
    component: () => import('@/pages/customer-support/cskh/assign-staff/List.vue'),
    props: (route) => {
      const level = route.params.level;
      if (['STORE', 'MERCHANT_ACCOUNT', 'MERCHANT_OWNER'].includes(level)) {
        return { level };
      } else {
        return { level: null };
      }
    },
    meta: { isAuth: true, title: `Gán nhân viên | ${DOMAIN_TITLE}` },
  },
  {
    path: '/customer-support/add-staff-convert-ids',
    name: 'AssignStaffFromFilterServicesConvertIds',
    component: () => import('@/pages/customer-support/cskh/assign-staff/AddStaffConvertIds.vue'),
    meta: { isAuth: true, title: `Gán nhân viên | ${DOMAIN_TITLE}` },
  },
  {
    path: '/customer-support/add-staff-multi/:level',
    name: 'AssignStaffFromFilterServices',
    component: () => import('@/pages/customer-support/cskh/assign-staff/AssignFromFilterServices.vue'),
    props: (route) => {
      const level = route.params.level;
      if (['STORE', 'MERCHANT_ACCOUNT', 'MERCHANT_OWNER'].includes(level)) {
        return { level };
      } else {
        return { level: null };
      }
    },
    meta: { isAuth: true, title: `Gán nhân viên | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/mc-sme",
    name: "MCSME",
    component: () => import("@/pages/customer-support/cskh/account/listSME.vue"),
    meta: { isAuth: true, title: `MC ưu đãi SME | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/account",
    name: "Merchant Account",
    component: () => import("@/pages/customer-support/cskh/account/list.vue"),
    meta: { isAuth: true, title: `Merchant account | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/account/:id",
    name: "Merchant Account Detail",
    component: () => import("@/pages/customer-support/cskh/account/detail.vue"),
    meta: { isAuth: true, title: `Merchant account detail | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/account/:id/history-assign",
    name: "AccountAssignhistory",
    component: () =>
      import(
        "@/pages/customer-support/cskh/account/components/historyAssign.vue"
      ),
    meta: { isAuth: true, title: `Assign history | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/account/:id/history-remove-assign",
    name: "AssignRemoveHistory",
    component: () => import("@/pages/customer-support/cskh/account/components/historyRemove.vue"),
    meta: { isAuth: true, title: `Remove Assign History | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/account-qr",
    name: "MerchantAccountQR",
    component: () => import("@/pages/customer-support/cskh/account/qrTab.vue"),
    meta: { isAuth: true, title: `Merchant account qr | ${DOMAIN_TITLE}` },
  },
  {
    path: '/customer-support/account-qr/:id/detail-sticker',
    name: 'StickerDetail',
    component: () => import('@/pages/customer-support/cskh/account/detailSticker.vue'),
    meta: { isAuth: true, title: `Chi tiết sticker | ${DOMAIN_TITLE}` }
  },
  {
    path: '/customer-support/account-qr-va/:id/detail-sticker',
    name: 'StickerDetailVa',
    component: () => import('@/pages/customer-support/cskh/account/detailStickerVa.vue'),
    meta: { isAuth: true, title: `Chi tiết sticker | ${DOMAIN_TITLE}` }
  },
  {
    path: '/customer-support/account-qr/:id/edit-sticker',
    name: 'StickerEdit',
    component: () => import('@/pages/customer-support/cskh/account/editSticker.vue'),
    meta: { isAuth: true, title: `Chi tiết sticker | ${DOMAIN_TITLE}` }
  },

  {
    path: "/customer-support/account-qr-print",
    name: "MerchantAccountQRPrint",
    component: () => import("@/pages/customer-support/cskh/account/qrCode.vue"),
    meta: {
      isAuth: true,
      title: `Merchant account qr print | ${DOMAIN_TITLE}`,
      layout: "blank",
    },
    props: true,
  },
  {
    path: "/customer-support/store",
    name: "StoreList",
    component: () => import("@/pages/customer-support/cskh/store/listv2.vue"),
    meta: { isAuth: true, title: `Merchant store | ${DOMAIN_TITLE}` },
  },

  {
    path: '/customer-support/store/create',
    name: 'StoreCreate',
    component: () => import('@/pages/customer-support/cskh/store/create.vue'),
    meta: { isAuth: true, title: `Thêm cửa hàng | ${DOMAIN_TITLE}` }
  },
  {
    path: "/customer-support/store/:id",
    name: "StoreDetail",
    component: () => import("@/pages/customer-support/cskh/store/detail.vue"),
    meta: { isAuth: true, title: `Store detail | ${DOMAIN_TITLE}` },
  },
  {
    path: '/customer-support/store/:id/edit',
    name: 'StoreEdit',
    component: () => import('@/pages/customer-support/cskh/store/create.vue'),
    meta: { isAuth: true, title: `Cập nhật cửa hàng | ${DOMAIN_TITLE}` }
  },
  {
    path: '/customer-support/store/:id/history-assign',
    name: 'StoreAssignHistory',
    component: () => import('@/pages/customer-support/cskh/store/components/historyAssign.vue'),
    meta: { isAuth: true, title: `Lịch sử gán | ${DOMAIN_TITLE}` }
  },
  {
    path: '/customer-support/store/:id/history-remove-assign',
    name: 'StoreRemoveAssignHistory',
    component: () => import('@/pages/customer-support/cskh/store/components/historyRemove.vue'),
    meta: { isAuth: true, title: `Lịch sử gỡ gán | ${DOMAIN_TITLE}` }
  },
  {
    path: "/customer-support/order-store",
    name: "OrderStoreList",
    component: () => import("@/pages/customer-support/cskh/order-store/list.vue"),
    meta: { isAuth: true, title: `Danh sách phiếu duyệt chi nhánh | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/order-store/:id",
    name: "OrderStoreDetail",
    component: () => import("@/pages/customer-support/cskh/order-store/detail.vue"),
    meta: { isAuth: true, title: `Chi tiết phiếu duyệt chi nhánh | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/contact",
    name: "Merchant Contact",
    component: () => import("@/pages/customer-support/cskh/contact/listv2.vue"),
    meta: { isAuth: true, title: `Merchant contact | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/contact/create",
    name: "Contact create",
    component: () => import("@/pages/customer-support/cskh/contact/create.vue"),
    meta: { isAuth: true, title: `Thêm liên hệ | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/contact/:id",
    name: "Merchant Contact detail",
    component: () => import("@/pages/customer-support/cskh/contact/detail.vue"),
    meta: { isAuth: true, title: `Chi tiết liên hệ | ${DOMAIN_TITLE}` },
  },
  {
    path: '/customer-support/contact/:id/edit',
    name: 'Contact Edit',
    component: () => import('@/pages/customer-support/cskh/contact/create.vue'),
    meta: { isAuth: true, title: `Cập nhật liên hệ | ${DOMAIN_TITLE}` }
  },

  {
    path: "/customer-support/contract",
    name: "Merchant Contract",
    component: () => import("@/pages/customer-support/cskh/contract/list.vue"),
    meta: { isAuth: true, title: `Merchant contract | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/contract/:id",
    name: "Merchant Contract detail",
    component: () =>
      import("@/pages/customer-support/cskh/contract/detail.vue"),
    meta: { isAuth: true, title: `Merchant contract detail | ${DOMAIN_TITLE}` },
  },

  {
    path: "/customer-support/task",
    name: "TaskList",
    component: () => import("@/pages/customer-support/cskh/task/List.vue"),
    meta: { isAuth: true, title: `Công việc | ${DOMAIN_TITLE}` },
  },

  {
    path: "/customer-support/task/new",
    name: "TaskAdd",
    component: () => import("@/pages/customer-support/cskh/task/AddTask.vue"),
    meta: { isAuth: true, title: `Thêm công việc | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/task/:id",
    name: "TaskDetail",
    component: () =>
      import("@/pages/customer-support/cskh/task/DetailTask.vue"),
    meta: { isAuth: true, title: `Chi tiết công việc | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/task/:id/edit",
    name: "TaskEdit",
    component: () => import("@/pages/customer-support/cskh/task/AddTask.vue"),
    meta: { isAuth: true, title: `Cập nhật công việc | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/task/:id/process",
    name: "TaskProcess",
    component: () => import("@/pages/customer-support/cskh/task/ProcessTask.vue"),
    meta: { isAuth: true, title: `Xử lý công việc | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/task/collected-info/:id",
    name: "TaskCollectedInfo",
    component: () =>
      import("@/pages/customer-support/cskh/task/CollectedInfo.vue"),
    meta: { isAuth: true, title: `Công việc | ${DOMAIN_TITLE}` },
  },
  {
    path: "/customer-support/tpv-ma",
    name: "TpvMa",
    component: () => import("@/pages/customer-support/cskh/tpv/tpv-ma.vue"),
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Doanh số giao dịch MA (TPV)`,
    },
  },
  {
    path: "/customer-support/tpv-ma/:id",
    name: "TpvMaDetail",
    component: () => import("@/pages/customer-support/cskh/tpv/detail.vue"),
    meta: {
      isAuth: true,
      title: `Chi tiết doanh số giao dịch MA | ${DOMAIN_TITLE}`,
    },
  },
  {
    path: "/customer-support/group-user",
    name: "GroupUserList",
    component: () => import("@/pages/customer-support/cskh/group-user/list.vue"),
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách nhóm người dùng`,
    },
  },
  {
    path: "/customer-support/group-user/create",
    name: "GroupUserCreate",
    component: () => import("@/pages/customer-support/cskh/group-user/HandleGroupUser.vue"),
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm mới nhóm người dùng`,
    },
  },
  {
    path: "/customer-support/group-user/edit/:id",
    name: "GroupUserEdit",
    component: () => import("@/pages/customer-support/cskh/group-user/HandleGroupUser.vue"),
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Sửa nhóm người dùng`,
    },
  },
  {
    path: "/customer-support/group-user/:id",
    name: "GroupUserDetail",
    component: () => import("@/pages/customer-support/cskh/group-user/Detail.vue"),
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết nhóm người dùng`,
    },
  },{
    path: '/customer-support/assign-order',
    name: 'AssignOrder',
    component: () => import('@/pages/customer-support/cskh/assign-order/list.vue'),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu duyệt gán ` }
  },
  {
    path: '/customer-support/assign-order/:id',
    name: 'AssignOrderDetail',
    component: () => import('@/pages/customer-support/cskh/assign-order/detail.vue'),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết phiếu yêu cầu ` }
  },
  {
    path: "/call-io",
    name: "ListCallIo",
    component: listCallIo,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách CallIO` },
  },
  {
    path: "/call-io/:id",
    name: "DetailCallIo",
    component: detailCallIo,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết CallIO` },
  },
  {
    path: "/quantity-material",
    name: "ListQuantityMaterial",
    component: listQuantityMaterial,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách điều chỉnh số lượng vật tư`,
    },
  },
  {
    path: "/quantity-material/add",
    name: "AddQuantityMaterial",
    component: requestQuantityMaterial,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm phiếu điều chỉnh số lượng vật tư`,
    },
  },
  {
    path: "/quantity-material/edit/:id",
    name: "EditQuantityMaterial",
    component: requestQuantityMaterial,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Sửa phiếu điều chỉnh số lượng vật tư`,
    },
  },
  {
    path: "/quantity-material/:id",
    name: "detailQuantityMaterial",
    component: detailQuantityMaterial,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Sửa phiếu điều chỉnh số lượng vật tư`,
    },
  },
  {
    path: "/delete-account-instruction",
    name: "deleteAccountInstruction",
    component: deleteAccountInstruction,
    meta: {
      isAuth: false,
      title: `${DOMAIN_TITLE} | Hướng dẫn xóa tài khoản`,
      layout: "login",
    },
  },
  {
    path: "/projects",
    name: "Projects redmine",
    component: () => import("@/pages/projects/index.vue"),
    meta: { isAuth: true, title: `Công việc | ${DOMAIN_TITLE}` },
  },
  {
    path: "/data-sms",
    name: "dataSms",
    component: dataSms,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Dữ liệu sms` },
  },
  {
    path: "/config-location",
    name: "configLocation",
    component: configLocation,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cấu hình khu vực` },
  },
  {
    path: "/feedback/:ticketId/:secretId",
    name: "Feedback",
    component: () => import("@/pages/feedback/index.vue"),
    meta: {
      isAuth: false,
      title: `Đánh giá | ${DOMAIN_TITLE}`,
      layout: "login",
    },
  },
  {
    path: "/report-inventory",
    name: "reportInventory",
    component: reportInventory,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Xuất nhập thiết bị theo kho`,
    },
  },
  //Kpi sale
  {
    path: "/kpi-sale/config/list",
    name: "kpi sale config list",
    component: kpiConfigList,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | kpi sale config list` },
  },
  {
    path: "/kpi-sale/config/view/:id",
    name: "kpi sale config detail",
    component: kpiConfigDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | kpi sale config detail` },
  },
  {
    path: "/kpi-sale/kpi-order-get-list",
    name: "kpi order get list",
    component: kpiOrderGetList,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tổng hợp phiếu KPI` },
  },
  {
    path: "/kpi-sale/kpi-order-item-detail/:id",
    name: "kpi order item detail",
    component: kpiOrderItemDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách KPI tạm tính` },
  },
  {
    path: "/kpi-sale/kpi-order-tam-tinh",
    name: "kpi order tam tinh",
    component: kpiOrderTamTinh,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách KPI tạm tính` },
  },
  {
    path: "/policy-device",
    name: "policyDevice",
    component: policyDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chính sách thiết bị` },
  },
  {
    path: "/policy-device/add",
    name: "createPolicyDevice",
    component: requestPolicyDevice,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm mới chính sách thiết bị`,
    },
  },
  {
    path: "/policy-device/edit/:id",
    name: "editPolicyDevice",
    component: requestPolicyDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa chính sách thiết bị` },
  },
  {
    path: "/policy-device/:id",
    name: "detailPolicyDevice",
    component: detailPolicyDevice,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết chính sách thiết bị`,
    },
  },
  {
    path: "/usage-change",
    component: usageChange,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách phiếu chuyển mục đích sử dụng`,
    },
  },
  {
    path: "/usage-change/add",
    name: "createUsageChange",
    component: requestUsageChange,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm mới phiếu chuyển mục đích sử dụng`,
    },
  },
  {
    path: "/system-notification",
    name: "listNotificationSystem",
    component: listNotificationSystem,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách thông báo hệ thống`,
    },
  },
  {
    path: "/system-notification/create",
    name: "createNotificationSystem",
    component: requestNotificationSystem,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Thêm mới thông báo hệ thống`,
    },
  },
  {
    path: "/system-notification/edit/:id",
    name: "editNotificationSystem",
    component: requestNotificationSystem,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa thông báo hệ thống` },
  },
  {
    path: "/system-notification/:id",
    name: "detailNotificationSystem",
    component: detailNotificationSystem,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết thông báo hệ thống`,
    },
  },
  {
    path: "/camera",
    name: "camera",
    component: cameraTest,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết thông báo hệ thống`,
    },
  },
  {
    path: "/usage-change",
    name: "usageChange",
    component: usageChange,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách phiếu chuyển mục đích sử dụng`,
    },
  },
  {
    path: "/usage-change/:id",
    name: "detailUsageChange",
    component: detailUsageChange,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Chi tiết phiếu chuyển mục đích sử dụng`,
    },
  },
  {
    path: "/usage-change/edit/:id",
    name: "updateUsageChange",
    component: requestUsageChange,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Sửa phiếu chuyển mục đích sử dụng`,
    },
  },
  {
    path: "/tpv",
    name: "listTPV",
    component: listTPV,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách TPV` },
  },
  {
    path: "/tpv/:email/:date",
    name: "detailTPV",
    component: detailTPV,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết TPV` },
  },
  {
    path: "/preferential-merchant-registration",
    name: "listPreferentialMerchantRegistration",
    component: preferentialMerchantRegistration,
    meta: {
      isAuth: true,
      title: `${DOMAIN_TITLE} | Danh sách phiếu đăng ký MC ưu đãi`,
    },
  },
  {
    path: "/preferential-merchant-registration/create",
    name: "createPreferentialMerchantRegistration",
    component: processingIncentiveRegistration,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo phiếu đăng ký ưu đãi` },
  },
  {
    path: "/preferential-merchant-registration/edit/:id",
    name: "updatePreferentialMerchantRegistration",
    component: processingIncentiveRegistration,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Sửa phiếu đăng ký ưu đãi` },
  },
  ,
  {
    path: "/preferential-merchant-registration/detail/:id",
    name: "detailPreferentialMerchantRegistration",
    component: detailIncentiveRegistration,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Phiếu đăng ký ưu đãi` },
  },
  {
    path: "/tpv-merchant",
    name: "tpvMerchant",
    component: tpvMerchant,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | TPV Merchant` },
  },
  {
    path: "/tpv-merchant-t7",
    name: "tpvMerchantT7",
    component: tpvMerchantT7,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | TPV Merchant` },
  },
  {
    path: "/rent-device",
    name: "rentDevice",
    component: rentDevice,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách thuê thiết bị` },
  },
  {
    path: "/paper-contract-manager",
    name: "paperContractManager",
    component: paperContractManager,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Quản lý HĐ/PL giấy` },
  },
  {
    path: "/paper-contract-manager/:id",
    name: "detailPaperContractManager",
    component: detailPaperContractManager,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết quản lý HĐ/PL giấy` },
  },
  {
    path: "/rent-device/:id",
    name: "rentDeviceDetail",
    component: () => import("@/pages/device/rent-device/detail.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết thuê thiết bị` },
  },
  {
    path: "/customer-support/add-task-merchant",
    name: "merchantTask",
    component: () => import('@/pages/customer-support/cskh/task/listTask.vue'),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới CV - list MA` },
  },
  {
    path: '/customer-support/add-task-convert-ids',
    name: 'Gán nhân viên từ filter-service',
    component: () => import('@/pages/customer-support/cskh/task/ConvertIds.vue'),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới CV - list MA` },
  },
  {
    path: "/device-boxme",
    name: "BoxMeList",
    component: () => import("@/pages/device/boxme/list.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách thiết bị boxme` },
  },
  {
    path: "/device-boxme/:id",
    name: "BoxMeDetail",
    component: () => import("@/pages/device/boxme/detail.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết thiết thiết bị boxme` },
  },
    {
    path: '/order-form',
    name: 'OderFormList',
    component: ()=> import("@/pages/collaborators/oderForm/index.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu đặt hàng` }
  },
   {
    path: '/order-form-detail/:id',
    name: 'OderFormDetail',
    component: ()=> import("@/pages/collaborators/oderForm/detail.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết sách phiếu đặt hàng` }
  },
   {
    path: '/order-form-add-receipt/:id/:agentId',
    name: 'OderFormReceiptAdd',
    component: ()=> import("@/pages/collaborators/oderForm/addReceipt.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo phiếu thu đối tác` }
  },
   {
    path: '/agent-receipt-oder-form-edit/:id',
    name: 'agentOderFormReceiptAdd',
    component: ()=> import("@/pages/device/agent-receipt/updateReceipt.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật phiếu thu đối tác` }
  },
   {
    path: '/order-form-add/:id',
    name: 'OderFormAdd',
    component: ()=> import("@/pages/collaborators/oderForm/edit.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm phiếu đặt hàng` }
  },

  {
    path: '/work-subsection-afs',
    name: 'workSubsectionAFS',
    component: ()=> import("@/pages/calendarAFS/workSubsection/index.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tiểu mục công việc` }
  },

  {
    path: '/work-subsection-afs/:id',
    name: 'workSubsectionAFSDetail',
    component: ()=> import("@/pages/calendarAFS/workSubsection/detail.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết tiểu mục công việc` }
  },

    {
    path: '/work-subsection-afs-add',
    name: 'workSubsectionAFSAdd',
    component: ()=> import("@/pages/calendarAFS/workSubsection/add.vue"),
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết tiểu mục công việc` }
  },
];
